import { z } from "zod";
import { AttrTypeName } from "./AttrType";
import { zUid } from "./zUid";

export const zArticleNumberMetaObjRef = z.object({
  valueTypeName: z.literal(AttrTypeName.object),
  attributeId: zUid,
  refAttributeId: zUid,
});
export const zArticleNumberMeta = z.discriminatedUnion("valueTypeName", [
  zArticleNumberMetaObjRef,
]);

export const zArticleNumberInfoAttr = z.object({
  linePart: z.string(),
  attributeId: zUid,
  quantitySymbols: z.number(),
  replaceLine: z.string(),
});
export const zArticleNumberInfo = z.object({
  maskLine: z.string(),
  alphanumericCounter: z.boolean().optional(),
  groupBy: z
    .object({
      attrIds: zUid.array().nullable(),
      quantitySymbols: z.number(),
      counterStart: z.number(),
    })
    .nullable(),
  attributes: zArticleNumberInfoAttr.array(),
  attributeMetas: zArticleNumberMeta.array().nullable(),
});
export type ZArticleNumberMetaObjRef = z.infer<typeof zArticleNumberMetaObjRef>;
export type ZArticleNumberMeta = z.infer<typeof zArticleNumberMeta>;
export type ZArticleNumberInfoAttr = z.infer<typeof zArticleNumberInfoAttr>;
export type ZArticleNumberInfo = z.infer<typeof zArticleNumberInfo>;
